import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <p>&copy; 2024 KaiOS Technologies. All rights reserved.</p>
        </footer>
    );
}

export default Footer;
